<div class="details-container" *ngIf="!loading">

    <div class="row">
        <div class="col-md-3 label">{{ 'bikeshop.modal.update_job_card.collections.collection' | translate}}:</div>
        <div class="col-md-3">
            <p-inputSwitch [(ngModel)]="allowCollection"
                           [disabled]="jobcard.StatusID >= 40 || collection.statusID == 10">
            </p-inputSwitch>
        </div>
        <div class="col-md-2 label" *ngIf="allowCollection">{{ 'bikeshop.modal.update_job_card.collections.collected' |
            translate}}:
        </div>
        <div class="col-md-4" *ngIf="allowCollection">
            <p-inputSwitch [(ngModel)]="collected" [disabled]="collected && (delivered || jobcard.StatusID >= 40)">
            </p-inputSwitch>
        </div>
    </div>

    <div class="row margin-top-8" *ngIf="allowCollection">
        <div class="col-md-3 label" [ngClass]="{'red': allowCollection && !collection.fullAddress}">
            {{ 'bikeshop.modal.update_job_card.collections.collection_address' | translate }}:
        </div>
        <div class="col-md-9">
            <div class="p-inputgroup">
                <p-autoComplete [(ngModel)]="collection.fullAddress" [suggestions]="addressOptions"
                                (completeMethod)="search($event, 'COLLECTION')"
                                (onSelect)="onSelect($event,'COLLECTION')" field="address"
                                [disabled]="jobcard.StatusID >= 40"></p-autoComplete>
                <div *ngIf="collectionAddrssLoading">
                    <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="2" fill="transparent"
                                       animationDuration=".5s">
                    </p-progressSpinner>
                </div>
            </div>
        </div>
    </div>

    <div class="row margin-top-8" *ngIf="countryData.code === 'GB' && collection.fullAddress">
        <div class="col-md-3 label">
            {{ 'bikeshop.collections.postal_code' | translate }}:
        </div>
        <div class="col-md-9 label">
            {{collection.postalCode}}
        </div>
    </div>

    <div class="row margin-top-8" *ngIf="!collectionAddrssLoading && collection.addressOutOfRange">
        <div class="col-md-3"></div>
        <div class="col-md-9 label red">{{'bikeshop.modal.shedule_service.collections_address_out_of_range' | translate}}</div>
    </div>

    <div class="row margin-top-8" *ngIf="allowCollection">
        <div class="col-md-3 label" [ngClass]="{'red': !collection.scheduleDate}">{{
            'bikeshop.modal.update_job_card.collections.collection_date' | translate}}:
        </div>
        <div class="col-md-3 value">
            <p-calendar dateFormat="{{countryData.DatePickerFormat}}"
                        placeholder="{{ 'bikeshop.modal.update_job_card.collections.collection_date' | translate}}"
                        [minDate]="minDate"
                        [maxDate]="maxDate" [(ngModel)]="collection.scheduleDate"
                        [disabledDates]="unavailableCollectionDates"
                        [disabled]="!collection.areaID || jobcard.StatusID >= 40"
                        (onSelect)="setBookingDate(true, 'COLLECTION')"
                        (onMonthChange)="monthChanged($event, 'COLLECTION')" [showOtherMonths]="false"></p-calendar>
        </div>
        <div class="col-md-2 label"
             [ngClass]="{'red': allowCollection && (!collection.timeSlot || !collection.timeSlot.deliveryVehicleID)}">{{
            'bikeshop.modal.update_job_card.collections.collection_time_slot' | translate}}:
        </div>
        <div class="col-md-4">
            <p-dropdown [options]="collectionTimeSlots" (onChange)="selectTimeSlot($event, 'COLLECTION')"
                        [disabled]="jobcard.StatusID >=40 || collection.scheduleDate === null || collectionTimeSlots.length === 0"
                        [ngModel]="collection.timeSlot" optionLabel="label"
                        placeholder="{{ 'bikeshop.modal.update_job_card.collections.collection_time_slot' | translate}}"></p-dropdown>
        </div>
    </div>
    <div class="row margin-top-16 red" *ngIf="!hasCollectionSlots && allowCollection">
        <div class="col-md-12">
            <small class="red">{{'bikeshop.modal.update_job_card.collections.no_collection_time_slots' | translate}}</small>
        </div>
    </div>

    <div class="row margin-top-8" *ngIf="allowCollection">
        <div class="col-md-3 label">{{ 'bikeshop.modal.update_job_card.collections.customer_notes' | translate }}:</div>
        <div class="col-md-9">
            <div class="p-inputgroup">
                <input type="text" pInputText [(ngModel)]="collection.notes" [disabled]="jobcard.StatusID >= 40"
                       placeholder="{{ 'bikeshop.modal.update_job_card.collections.customer_notes' | translate }}"/>
            </div>
        </div>
    </div>

</div>


<div class="details-container margin-top-16">

    <div class="row">
        <div class="col-md-3 label">{{ 'bikeshop.modal.update_job_card.collections.delivery' | translate}}:</div>
        <div class="col-md-3">
            <p-inputSwitch [(ngModel)]="allowDelivery" [disabled]="jobcard.StatusID === 50"></p-inputSwitch>
        </div>
        <div class="col-md-2 label" *ngIf="allowDelivery && jobcard.StatusID > 40">{{
            'bikeshop.modal.update_job_card.collections.delivered' |
                translate}}:
        </div>
        <div class="col-md-4" *ngIf="allowDelivery && jobcard.StatusID > 40">
            <p-inputSwitch [(ngModel)]="delivered" [disabled]="jobcard.StatusID < 40 && delivery.statusID !== 20">
            </p-inputSwitch>
        </div>
    </div>

    <div class="row margin-top-8"
         *ngIf="(allowDelivery && jobcard.StatusID > 40) || (allowDelivery && !allowCollection)">
        <div class="col-md-3 label"
             [ngClass]="{'red': allowDelivery && !delivery.fullAddress && jobcard.StatusID > 40}">
            {{ 'bikeshop.modal.update_job_card.collections.delivery_address' | translate }}:
        </div>
        <div class="col-md-9">
            <div class="p-inputgroup">
                <p-autoComplete [(ngModel)]="delivery.fullAddress" [suggestions]="addressOptions"
                                (completeMethod)="search($event, 'DELIVERY')" (onSelect)="onSelect($event,'DELIVERY')"
                                field="address"
                                [disabled]="allowCollection && jobcard.StatusID < 40"></p-autoComplete>
                <div *ngIf="deliveryAddrssLoading">
                    <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="2" fill="transparent"
                                       animationDuration=".5s">
                    </p-progressSpinner>
                </div>
            </div>
        </div>
    </div>
    <div class="row margin-top-8" *ngIf="countryData.code === 'GB' && delivery.fullAddress">
        <div class="col-md-3 label">
            {{ 'bikeshop.collections.postal_code' | translate }}:
        </div>
        <div class="col-md-9 label">
            {{delivery.postalCode}}
        </div>
    </div>
    <div class="row margin-top-8" *ngIf="!deliveryAddrssLoading && delivery.addressOutOfRange">
        <div class="col-md-3"></div>
        <div class="col-md-9 label red">{{'bikeshop.modal.shedule_service.collections_address_out_of_range' | translate}}</div>
    </div>

    <div class="row margin-top-8" *ngIf="allowDelivery && jobcard.StatusID > 40">
        <div class="col-md-3 label"
             [ngClass]="{'red': allowDelivery && jobcard.StatusID > 40 && !delivery.scheduleDate}">{{
            'bikeshop.modal.update_job_card.collections.delivery_date' | translate}}:
        </div>
        <div class="col-md-3 value">
            <p-calendar dateFormat="{{countryData.DatePickerFormat}}"
                        placeholder="{{ 'bikeshop.modal.update_job_card.collections.delivery_date' | translate}}"
                        [minDate]="minDate"
                        [maxDate]="maxDate" [(ngModel)]="delivery.scheduleDate"
                        [disabledDates]="unavailableDeliveryDates"
                        [disabled]="!delivery.areaID || jobcard.StatusID < 40"
                        (onSelect)="setBookingDate(true, 'DELIVERY')"
                        (onMonthChange)="monthChanged($event, 'DELIVERY')" [showOtherMonths]="false"></p-calendar>
        </div>
        <div class="col-md-2 label"
             [ngClass]="{'red': allowDelivery && jobcard.StatusID > 40 && (!delivery.timeSlot || !delivery.timeSlot.deliveryVehicleID)}">
            {{
            'bikeshop.modal.update_job_card.collections.delivery_time_slot' | translate}}:
        </div>
        <div class="col-md-4">
            <p-dropdown [options]="deliveryTimeSlots" (onChange)="selectTimeSlot($event, 'DELIVERY')"
                        [disabled]="jobcard.StatusID <40 || delivery.scheduleDate === null || deliveryTimeSlots.length === 0"
                        [ngModel]="delivery.timeSlot" optionLabel="label"
                        placeholder="{{ 'bikeshop.modal.update_job_card.collections.collection_time_slot' | translate}}"></p-dropdown>
        </div>
    </div>
    <div class="row margin-top-16" *ngIf="!hasDeliverySlots && allowDelivery">
        <div class="col-md-12">
            <small class="red">{{'bikeshop.modal.update_job_card.collections.no_delivery_time_slots' | translate}}</small>
        </div>
    </div>

    <div class="row margin-top-8" *ngIf="allowDelivery && jobcard.StatusID > 40">
        <div class="col-md-3 label">{{ 'bikeshop.modal.update_job_card.collections.customer_notes' | translate }}:</div>
        <div class="col-md-9">
            <div class="p-inputgroup">
                <input type="text" [disabled]="jobcard.StatusID < 40" pInputText [(ngModel)]="delivery.notes"
                       placeholder="{{ 'bikeshop.modal.update_job_card.collections.customer_notes' | translate }}"/>
            </div>
        </div>
    </div>

    <div class="row margin-top-16" *ngIf="allowDelivery && jobcard.StatusID < 40">
        <div class="col-md-12">
            <small>***{{ 'bikeshop.modal.update_job_card.collections.delivery_info' | translate }}</small>
        </div>
    </div>

</div>


<div class="row margin-top-16">
    <div class="col-md-9 flex">
        <div class="red bold" *ngIf="!validate() && ! loading && !collectionAddrssLoading && !deliveryAddrssLoading">
            {{ 'bikeshop.modal.update_job_card.collections.not_valid' | translate }}
        </div>
    </div>
    <div class="col-md-3">
        <button pButton type="button" [disabled]="!validate() || busySaving" class="p-button-raised full-width"
                label="{{
        'bikeshop.modal.update_job_card.collections.save_collection' | translate
      }}" (click)="updateCollection()"></button>
    </div>
</div>
